<template>
  <div id="tree-wrapper" v-if="isShowTree">
    <div class="toggle-wrap">
      <div class="toggle-btn-box">
        <div class="toggle-btn" :class="{active: toggleTemplate}" @click="toggleTemplate = true">原始模板</div>
        <div class="toggle-btn" :class="{active: !toggleTemplate}" @click="toggleTemplate = false">自定义模板</div>
      </div>
    </div>
    <div class="primeval-template" v-show="toggleTemplate">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText" size="mini" style="margin-top:10px;"
                @input="filterChange"></el-input>
      <div class="tree-box">
        <el-tree style="background-color: inherit;"
                 :data="treeData"
                 :props="defaultProps"
                 @node-click="handleNodeClick"
                 @node-expand="nodeExpand"
                 @node-collapse="nodeCollapse"
                 :render-content="renderContent"
                 :filter-node-method="filterNode"
                 :highlight-current="true"
                 ref="tree"
                 class="my_tree">

        </el-tree>
      </div>
    </div>
    <div class="custom-template" v-show="!toggleTemplate">
      <el-input placeholder="输入关键字进行过滤" v-model="filterText2" size="mini" style="margin-top:10px;"></el-input>
      <div class="tree-box" @scroll="scrollChange">
        <el-tree style="background-color: inherit;"
                 :data="treeData2"
                 :props="defaultProps2"
                 @node-click="handleNodeClick"
                 @node-expand="nodeExpand"
                 @node-collapse="nodeCollapse"
                 :render-content="renderContent2"
                 :filter-node-method="filterNode2"
                 :highlight-current="true"
                 ref="tree2"
                 class="my_tree">

        </el-tree>
      </div>
    </div>

    <el-dialog title="添加" :visible.sync="dialogFormVisible" :show-close="false"
                width="600px" :close-on-click-modal="false">
      <el-form :model="form">
        <el-input v-model="form.value" type="textarea" :autosize="{ minRows: 2}" placeholder="请输入模板内容"></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveTemplate">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="dialogEdit"
      width="30%"
      :close-on-click-modal="false">
      <el-input
        type="textarea"
        :autosize="{ minRows: 2}"
        placeholder="请输入内容"
        v-model="editDataValue">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEdit = false">取 消</el-button>
        <el-button type="primary" @click="editDataConfirm(handleType)">确 定</el-button>
      </span>
    </el-dialog>
    <div class="contextmenu-node contextmenu" v-show="contextmenuNode" :style="'left:'+nodeLeft+';top:'+nodeTop" @mousedown="menuRightClick">
      <ul>
        <li class="item" @click="nodeClick('add', 'dis')">新建模板</li>
        <!--<li class="item" @click="nodeClick('add', 'node')">新建病种</li>-->
        <li class="item" @click="nodeClick('edit', 'node')">编辑病种</li>
        <li class="item" @click="nodeClick('delete', 'node')">删除病种</li>
      </ul>
    </div>
    <div class="contextmenu-second contextmenu" v-show="contextmenuSecond" :style="'left:'+secondLeft+';top:'+secondTop"
         @mousedown="menuRightClick">
      <ul>
        <li class="item" @click="nodeClick('add', 'node')">新建病种</li>
        <!--<li class="item" @click="nodeClick('add', 'subclass')">新建病类</li>-->
        <li class="item" @click="nodeClick('edit', 'subclass')">编辑病类</li>
        <li class="item" @click="nodeClick('delete', 'subclass')">删除病类</li>
      </ul>
    </div>
    <div class="contextmenu-tpl contextmenu" v-show="contextmenuTpl" :style="'left:'+tplLeft+';top:'+tplTop"
         @mousedown="menuRightClick">
      <ul>
        <li class="item" @click="nodeClick('add', 'dis')">新建模板</li>
        <li class="item" @click="nodeClick('edit', 'dis')">编辑模板</li>
        <li class="item" @click="nodeClick('delete', 'dis')">删除模板</li>
      </ul>
    </div>
    <div class="contextmenu-tpl contextmenu" v-show="contextmenuClass" :style="'left:'+classLeft+';top:'+classTop"
         @mousedown="menuRightClick">
      <ul>
        <li class="item" @click="nodeClick('add', 'subclass')">新建病类</li>
        <li class="item" @click="nodeClick('add', 'node')">新建病种</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import gql from 'graphql-tag';
  import api from '../api';
  import _ from 'lodash';
  export default {
    name: '',
    props: {
      diagnoseType: {
        type: String,
        default: () => {
          return '';
        }
      },
      treeReload: Boolean,
    },
    data() {
      return {
        contextmenuNode: false,
        contextmenuSecond: false,
        contextmenuTpl: false,
        contextmenuClass: false,
        nodeLeft: '0px',
        nodeTop: '0px',
        secondLeft: '0px',
        secondTop: '0px',
        tplLeft: '0px',
        tplTop: '0px',
        classLeft: '0px',
        classTop: '0px',

        isShowTree: true,
        toggleTemplate: false,
        treeData: [],
        treeData2: [],
        data: [],
        defaultProps: {
          children: 'children',
          label: 'name',
        },
        defaultProps2: {
          children: 'children',
          label: 'name',
        },
        showEdit: false,
        formLabelWidth: '80px',
        dialogFormVisible: false,
        dialogFormAddDisease: false,
        dialogFormDelete: false,
        dialogEdit: false,
        dialogEditDisease: false,
        form: {
          value: '',
          name: '',
        },
        filterText:'',
        filterText2: '',
        nodeData:{},
        treeNode: {},
        expandAttribute: '',
        templateId: '',
        editDataValue: '',
        editDiseaseValue: '',
        // 自定义模板
        template: {
          second: [],
          dermoscopy: {},
          ct: {},
          b_ultrasonic: {},
          pathology: {},
          top5Knowledge: {
            dermoscopy: [],
            ct: [],
            b_ultrasonic: [],
            pathology: [],
          },
        },
        // 模板建议数据
        knowledgeDic: {},
        // 筛选内容符合的病名id
        filterIdArr: [],
        filterIdArr2: [],
        handleType: '',
      }
    },
    methods: {
      // 筛选内容改变时
      filterChange() {
        // .replace(/\s*/g, "")
        const value = this.filterText.replace(/\s*/g, "");
        if (value !== '') {
            const knowledgeDicObj = this.knowledgeDic;
            const arr = [];
            for (const key in knowledgeDicObj) {
              if (knowledgeDicObj[key].name.indexOf(value) > -1) {
                arr.push(key);
              }
            }
            this.filterIdArr = arr;
        } else {
          this.filterIdArr = [];
        }
      },
      // 节点点击触发事件
      handleNodeClick(data) {
        this.contextmenuNode = false;
        this.contextmenuTpl = false;
        this.contextmenuSecond = false;
        this.contextmenuClass = false;
      },
      // 节点展开时触发事件
      nodeExpand() {
        this.contextmenuNode = false;
        this.contextmenuTpl = false;
        this.contextmenuSecond = false;
        this.contextmenuClass = false;
      },
      // 节点折叠时触发事件
      nodeCollapse() {
        this.contextmenuNode = false;
        this.contextmenuTpl = false;
        this.contextmenuSecond = false;
        this.contextmenuClass = false;
      },
      // 节点右击
      nodeClick(value, type) {
        if (value === 'add') {
          this.form.value = '';
          this.handleType = type;
          this.dialogFormVisible = true;
        } else if (value === 'delete') {
          let msg;
          if (type === 'dis') {
            msg = '确定要删除吗？';
          } else if (type === 'node') {
            msg = '删除病种后其他模态下的该病种也会删除，并且该病种下的所有模板都将删除，确定要删除吗？';
          } else if (type === 'subclass') {
            msg = '删除病类后其他模态下的该病类也会删除，并且该病种下的所有病种和模板都将删除，确定要删除吗？';
          }
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            this.deleteTemplate(type);
          }).catch((error) => {
            // console.log(error)
          });
        } else if (value === 'edit') {
          this.dialogEdit = true;
          this.handleType = type;
          this.editDataValue = this.nodeData.name;
        }
      },
      // 筛选
      filterNode(value, data) {
        if (!value) {
          return true;
        }
        const reg = /\D+-/;
        let newId = '';
        if (reg.test(data.id)) {
          const a = data.id.split('-');
          a.splice(a.length - 1, 1);
          newId = a.join('-').replace(/\D+-/, '');
        }
        const filterIdArr = this.filterIdArr;
        let status = false;
        for (const item of filterIdArr) {
          if (data.id === item || newId === item) {
            status = true;
          }
        }
        return status;
      },
      filterNode2(value, data) {
        if (!value) {
          return true;
        }
        return this.filterIdArr2.findIndex(item => data.id === item) > -1;
      },
      renderContent(createElement, { node, data, store }) {
        return createElement('span',{attrs:{style: (() => {
              if (data.dis === true) {
                return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default;padding-left: 36px';
              } else if (data.node === true) {
                if (!data.children || data.children.length === 0) {
                  return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default;padding-left: 36px';
                } else {
                  return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default';
                }
              } else {
                return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default';
              }
            })()
              },on: {click: (event) => {
              event.stopPropagation();
              node.expanded ? node.collapse() : node.expand();
              this.contextmenuNode = false;
              this.contextmenuTpl = false;
              this.contextmenuSecond = false;
              this.contextmenuClass = false;
            }}},[
          createElement('div', {attrs:{style: (() => {
            if (data.dis === true && data.predefine === true) {
              return 'flex:1;color: #444;font-size: 12px;user-select: none;line-height:16px;';
            } else if (data.dis === true && data.predefine !== true) {
              return 'flex:1;color: #444;font-size: 12px;user-select: none;line-height:16px;background-color:#fff;';
            } else {
              return 'flex:1';
            }
          })(),class: 'node'},
          on: {mousedown: (event) => {
              if (event.button === 2) {
                event.stopPropagation();
                event.preventDefault();
                this.contextmenuNode = false;
                this.contextmenuTpl = false;
                this.contextmenuSecond = false;
                this.contextmenuClass = false;
              }
          }, dblclick: (event) => {   // 双击将病名或模板添加到对应位置
              event.stopPropagation();
              this.$emit('getContent', data);
            }}}, node.label),
        ]);
      },
      renderContent2(createElement, { node, data, store }) {
        return createElement('span',{attrs:{style: (() => {
              if (data.dis === true) {
                return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default;padding-left: 36px';
              } else if (data.node === true) {
                if (!data.children || data.children.length === 0) {
                  return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default;padding-left: 36px';
                } else {
                  return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default';
                }
              } else if (data.class === true || data.subclass === true) {
                if (!data.children || data.children.length === 0) {
                  return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default;padding-left: 36px';
                } else {
                  return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default';
                }
              } else {
                return 'flex:1;display:flex;justify-content: space-between;align-items: center;font-size: 15px;font-weight:bold;color: #222;user-select: none;padding: 5px 0;cursor:default';
              }
            })()
          },on: {click: (event) => {
              event.stopPropagation();
              node.expanded ? node.collapse() : node.expand();
              this.contextmenuNode = false;
              this.contextmenuTpl = false;
              this.contextmenuSecond = false;
              this.contextmenuClass = false;
            }}},[
          createElement('div', {attrs:{style: (() => {
                if (data.dis === true && data.predefine === true) {
                  return 'flex:1;color: #444;font-size: 12px;user-select: none;line-height:16px;';
                } else if (data.dis === true && data.predefine !== true) {
                  return 'flex:1;color: #444;font-size: 12px;user-select: none;line-height:16px;background-color:#fff;';
                } else {
                  return 'flex:1';
                }
              })(),class: 'node'},
            on: {contextmenu: (event) => {
                if (event.button === 2) {
                  event.stopPropagation();
                  event.preventDefault();
                  this.contextmenuNode = false;
                  this.contextmenuTpl = false;
                  this.contextmenuSecond = false;
                  this.contextmenuClass = false;
                  // 如果是子节点
                  // if (data.node || data.second || data.class) {
                  //   this.expandAttribute = node;
                  // } else {
                  //   this.expandAttribute = '';
                  // }
                  if (data.node === true) {
                    // 显示右击弹窗
                    this.nodeLeft = event.clientX+'px';
                    this.nodeTop = event.clientY+'px';
                    this.contextmenuNode = true;
                    this.contextmenuTpl = false;
                    this.contextmenuSecond = false;
                    this.contextmenuClass = false;
                    this.$emit('showMenu', true);
                    // 传出数据
                    this.templateId = data.id;
                    this.nodeData = data;
                    this.treeNode = node;
                    // 如果是自定义模板
                  } else if (data.dis === true) {
                    // 显示右击弹窗
                    this.tplLeft = event.clientX+'px';
                    this.tplTop = event.clientY+'px';
                    this.contextmenuTpl = true;
                    this.contextmenuNode = false;
                    this.contextmenuSecond = false;
                    this.contextmenuClass = false;
                    this.$emit('showMenu', true);
                    // 传出数据
                    this.templateId = data.id;
                    this.nodeData = data;
                    this.treeNode = node;
                    // 如果是亚型病种
                  } else if (data.subclass === true) {
                    // 显示右击弹窗
                    this.secondLeft = event.clientX+'px';
                    this.secondTop = event.clientY+'px';
                    this.contextmenuSecond = true;
                    this.contextmenuNode = false;
                    this.contextmenuTpl = false;
                    this.contextmenuClass = false;
                    this.$emit('showMenu', true);
                    // 传出数据
                    this.templateId = data.id;
                    this.nodeData = data;
                    this.treeNode = node;
                  } else if (data.class === true) {
                    this.classLeft = event.clientX+'px';
                    this.classTop = event.clientY+'px';
                    this.contextmenuSecond = false;
                    this.contextmenuNode = false;
                    this.contextmenuTpl = false;
                    this.contextmenuClass = true;
                    this.$emit('showMenu', true);
                    // 传出数据
                    this.templateId = data.id;
                    this.nodeData = data;
                    this.treeNode = node;
                  }
                }
              }, dblclick: (event) => {   // 双击将病名或模板添加到对应位置
                event.stopPropagation();
                if (data.node || data.dis) {
                  this.$emit('getContent', data);
                }
              }}}, node.label),
        ]);
      },
      // 从影像诊断添加结果到树中
      async addDiagnosisToMyTemplate(name) {
        const template = this.template.myTemplate;
        const type = this.diagnoseType;
        if (template[4].children) {
          const children = template[4].children;
          const findIndex = children.findIndex((item) => item.name === name);
          if (findIndex > -1) {
            this.$message.error('已添加过该诊断结果');
            return;
          } else {
            const maxId = this.computeMaxId(children);
            children.unshift({
              name,
              id: 5 + '-' + (maxId + 1),
              node: true,
            });
          }
        } else {
          template[4].children = [{
            name,
            id: 5 + '-1',
            node: true,
          }]
        }
  
        // 上传模板
        await this.uploadTemplate();
        // 重新加载刷新显示
        await this.request();
      },
      // 新建
      async saveTemplate() {
        const name = this.form.value;
        if (name === '') {
          this.$message.error('内容不能为空');
          return;
        }
        this.dialogFormVisible = false;
        if (this.handleType === 'dis') {
          this.createdTemplateNode();
        } else if (this.handleType === 'node') {
          this.createdNode();
        } else if (this.handleType === 'subclass') {
          this.createdSubclassNode();
        }
      },
      // 新建模板节点
      createdTemplateNode() {
        const name = this.form.value;
        const id = this.templateId;
        const nodeData = this.nodeData;
        const template = this.template.myTemplate;
        const type = this.diagnoseType;
        const type2 = this.diagnoseType + '_templates';
        // 更新tree显示
        if (nodeData.node === true) {   // 如果是病名节点
          const newChild = {
            id: type + '-' + id + '-1',
            name,
            dis: true,
          };
          if (!nodeData.children) {
            this.$set(nodeData, 'children', []);
          }
          nodeData.children.unshift(newChild);
          this.treeNode.expand();
    
    
          // 更新自定义模板
          const findData = this.findTreeObj(template, id);
          if (findData[type2]) {
            findData[type2].unshift(name);
          } else {
            findData[type2] = [];
            findData[type2].unshift(name);
          }
    
        } else if (nodeData.dis === true) {
    
          const treeData2 = this.treeData2;
          // 更改treeData2数据，显示更新
          const nodeId = id.replace(/-\d+$/, '').replace(/^\w+-/, '');
    
          const findData = this.findTreeObj(treeData2, nodeId);
          findData.children.unshift({
            name,
            id: type + '-' + nodeId + '-1',
            dis: true,
          });
    
          // 更新自定义模板
          const findData2 = this.findTreeObj(template, nodeId);
          findData2[type2].unshift(name);
        }
        // 上传模板
        this.uploadTemplate();
      },
      // 新建病种节点
      createdNode() {
        const name = this.form.value;
        const id = this.templateId;
        const nodeData = this.nodeData;
        const template = this.template.myTemplate;
        // 更新tree显示
        if (nodeData.subclass || nodeData.class) {
          const maxId = (nodeData.children && nodeData.children.length) ? this.computeMaxId(nodeData.children) : 0;
          const newChild = {
            id: id + '-' + (maxId + 1),
            name,
            node: true,
          };
          if (!nodeData.children) {
            this.$set(nodeData, 'children', []);
          }
          nodeData.children.unshift(newChild);
          this.treeNode.expand();
          // 更新自定义模板
          const findData2 = this.findTreeObj(template, id);
          if (findData2.children) {
            findData2.children.unshift({
              name,
              id: id + '-' + (maxId + 1),
            })
          } else {
            findData2.children = [{
              name,
              id: id + '-' + (maxId + 1),
            }];
          }
          
          
        } else if (nodeData.node) {
          const subclassId = id.replace(/-\d+$/, '');
          const findData = this.findTreeObj(this.treeData2, subclassId);
          const maxId = (findData.children && findData.children.length) ? this.computeMaxId(findData.children) : 0;
          findData.children.unshift({
            name,
            id: subclassId + '-' + (maxId + 1),
            node: true,
          });
          // 更新自定义模板
          const findData2 = this.findTreeObj(template, subclassId);
          if (findData2.children) {
            findData2.children.unshift({
              name,
              id: subclassId + '-' + (maxId + 1),
            })
          } else {
            findData2.children = [{
              name,
              id: subclassId + '-' + (maxId + 1),
            }];
          }
        }
  
        // 上传模板
        this.uploadTemplate();
      },
      // 新建病类节点
      createdSubclassNode() {
        const name = this.form.value;
        const id = this.templateId;
        const nodeData = this.nodeData;
        const template = this.template.myTemplate;
        if (nodeData.class) {
          const maxId = (nodeData.children && nodeData.children.length) ? this.computeMaxId(nodeData.children) : 0;
          const newChild = {
            id: id + '-' + (maxId + 1),
            name,
            subclass: true,
          };
          if (!nodeData.children) {
            this.$set(nodeData, 'children', []);
          }
          nodeData.children.unshift(newChild);
          this.treeNode.expand();
          // 更新自定义模板
          const findData2 = this.findTreeObj(template, id);
          if (findData2.children) {
            findData2.children.unshift({
              name,
              id: id + '-' + (maxId + 1),
              subclass: true,
            })
          } else {
            findData2.children = [{
              name,
              id: id + '-' + (maxId + 1),
              subclass: true,
            }];
          }
          
        } else if (nodeData.subclass) {
          const classId = id.replace(/-\d+$/, '');
          const findData = this.findTreeObj(this.treeData2, classId);
          const maxId = (findData.children && findData.children.length) ? this.computeMaxId(findData.children) : 0;
          findData.children.unshift({
            name,
            id: classId + '-' + (maxId + 1),
            subclass: true,
          });
          // 更新自定义模板
          const findData2 = this.findTreeObj(template, classId);
          if (findData2.children) {
            findData2.children.unshift({
              name,
              id: classId + '-' + (maxId + 1),
              subclass: true,
            })
          } else {
            findData2.children = [{
              name,
              id: classId + '-' + (maxId + 1),
              subclass: true,
            }];
          }
        }
  
  
        // 上传模板
        this.uploadTemplate();
      },
      // 编辑
      async editDataConfirm(value) {
        const name = this.editDataValue;
        if (name === '') {
          this.$message.error('内容不能为空');
          return;
        }
        if (value === 'dis') {
          this.editTemplateNode();
        } else if (value === 'node') {
          this.editNode();
        } else if (value === 'subclass') {
          this.editSubclassNode();
        }
        
      },
      // 编辑模板节点
      editTemplateNode() {
        const template = this.template.myTemplate;
        const id = this.templateId;
        const type = this.diagnoseType + '_templates';
        const nodeData = this.nodeData;
        const initialName = nodeData.name;
        const name = this.editDataValue;
        this.dialogEdit = false;
        // 改变tree树结构数据，更新显示
        this.nodeData.name = name;
        // 更新自定义模板
        const nodeId = id.replace(/-\d+$/, '').replace(/^\w+-/, '');
        const findData = this.findTreeObj(template, nodeId);
        const index = findData[type].findIndex(item => initialName === item);
        if (index > -1) {
          findData[type][index] = name;
        }
  
        // 上传模板
        this.uploadTemplate();
      },
      // 编辑病种节点
      editNode() {
        const template = this.template.myTemplate;
        const id = this.templateId;
        const name = this.editDataValue;
        this.dialogEdit = false;
        // 改变tree树结构数据，更新显示
        this.nodeData.name = name;
        // 更新自定义模板
        const findData = this.findTreeObj(template, id);
        findData.name = name;
        
        // 上传模板
        this.uploadTemplate();
      },
      editSubclassNode() {
        const template = this.template.myTemplate;
        const id = this.templateId;
        const name = this.editDataValue;
        this.dialogEdit = false;
        // 改变tree树结构数据，更新显示
        this.nodeData.name = name;
        // 更新自定义模板
        const findData = this.findTreeObj(template, id);
        findData.name = name;
  
        // 上传模板
        this.uploadTemplate();
      },
      // 删除模板
      deleteTemplate(handleType) {
        if (handleType === 'dis') {
          this.deleteTemplateNode();
        } else if (handleType === 'node') {
          this.deleteNode();
        } else if (handleType === 'subclass') {
          this.deleteSubclassNode();
        }
        
      },
      // 删除模板节点
      deleteTemplateNode() {
        const template = this.template.myTemplate;
        const id = this.templateId;
        const type = this.diagnoseType + '_templates';
        const nodeData = this.nodeData;
        // 更新tree显示
        this.treeNode.remove(this.treeNode, this.nodeData);
        // 更新自定义模板
        const nodeId = id.replace(/-\d+$/, '').replace(/^\w+-/, '');
        const findData = this.findTreeObj(template, nodeId);
        const index = findData[type].findIndex(item => nodeData.name === item);
        if (index > -1) {
          findData[type].splice(index, 1);
        }
  
        // 上传模板
        this.uploadTemplate();
      },
      // 删除病种节点
      deleteNode() {
        const template = this.template.myTemplate;
        const id = this.templateId;
        // 更新tree显示
        this.treeNode.remove(this.treeNode, this.nodeData);
        // 更新自定义模板
        const subclassId = id.replace(/-\d+$/, '');
        const findData = this.findTreeObj(template, subclassId);
        const index = findData.children.findIndex(item => id === item.id);
        if (index > -1) {
          findData.children.splice(index, 1)
        }
  
        // 上传模板
        this.uploadTemplate();
      },
      // 删除病类节点
      deleteSubclassNode() {
        const template = this.template.myTemplate;
        const id = this.templateId;
        // 更新tree显示
        this.treeNode.remove(this.treeNode, this.nodeData);
        // // 更新自定义模板
        const classId = id.replace(/-\d+$/, '');
        const findData = this.findTreeObj(template, classId);
        const index = findData.children.findIndex(item => id === item.id);
        if (index > -1) {
          findData.children.splice(index, 1)
        }
        
        // 上传模板
        this.uploadTemplate();
      },
      // 找到tree数据结构中对应id的对象
      findTreeObj(treeData, id) {
        let findData;
        const f = (data) => {
          for (let i = 0; i < data.length; i++) {
            if (data[i].id === id) {
              findData = data[i];
              break;
            } else if (data[i].children && data[i].children.length) {
              f(data[i].children);
            }
          }
        };
        f(treeData);
        return findData;
      },
      // 计算出children中最大的id
      computeMaxId(dataArr) {
        const idArr = dataArr.map(item => Number(item.id.match(/\d+$/)[0]));
        return Math.max(...idArr);
      },
      // 请求数据
      async request() {
        // this.uploadTemplate(); // 重置模板
        
        // 请求树结构数据
        const response = await axios.request({
          method: 'get',
          url: api.knowledge,
        });
        this.data = response.data.children;

        // 请求医生自定义的模板路径
        const res = await this.$apollo.query({
          query: gql`{
          me{
            id
            template
          }
        }`,
          fetchPolicy: 'no-cache',
        });
        // 根据路径请求模板
        const path = res.data.me.template;
        // 如果没有自定义模板
        if (path === '') {
          this.addTemplate();
          this.$emit('cloneTemplate', this.template);
          if (this.diagnoseType === '') {
            this.template.myTemplate = _.cloneDeep(this.data);
          }
          this.uploadTemplate();
          return;
        }
        const msg =  await axios.request({
          method: 'get',
          url: api.template + path,
        });
        this.template = msg.data;
        this.addTemplate();
        // 向父组件传一份自定义模板
        this.$emit('cloneTemplate', msg.data);
      },
      // 生成treeData数据
      handleTreeData(initialData) {
        const fn = (data) => {
          const type = this.diagnoseType + '_templates';
    
          for (let i = 0; i < data.length; i++) {
            if (!data[i].children) {
              data[i].node = true;
              if (data[i][type]) {
                data[i].children = [];
                for (let j = 0; j < data[i][type].length; j++) {
                  data[i].children.push({
                    name: data[i][type][j],
                    id: data[i].id,
                    dis: true,
                    predefine: true,
                  });
                }
              }
            } else {
              fn(data[i].children);
            }
          }
        };
        fn(initialData);
        return initialData;
      },
      // 生成treeData2数据
      handleTreeData2(initialData) {
        const fn = (data) => {
          const type = this.diagnoseType + '_templates';
    
          for (let i = 0; i < data.length; i++) {
            if (!data[i].children) {
              if (data[i].id !== '1' && data[i].id !== '2' && data[i].id !== '3' && data[i].id !== '4' && data[i].id !== '5' && !data[i].subclass) {
                data[i].node = true;
              } else if (data[i].id === '1' || data[i].id === '2' || data[i].id === '3' || data[i].id === '4' || data[i].id === '5') {
                data[i].class = true;
              }
              if (!data[i].class && !data[i].node) {
                data[i].subclass = true;
              }
              if (data[i][type]) {
                data[i].children = [];
                for (let j = 0; j < data[i][type].length; j++) {
                  data[i].children.push({
                    name: data[i][type][j],
                    id: this.diagnoseType + '-' + data[i].id + '-1',
                    dis: true,
                  });
                }
              }
            } else {
              if (data[i].id === '1' || data[i].id === '2' || data[i].id === '3' || data[i].id === '4' || data[i].id === '5') {
                data[i].class = true;
              }
              if (!data[i].class && !data[i].node) {
                data[i].subclass = true;
              }
              fn(data[i].children);
            }
          }
        };
        fn(initialData);
        return initialData;
      },
      addTemplate() {
        if (this.diagnoseType === '') {
          return;
        }
        const data = _.cloneDeep(this.data);
        // 生成原始模板
        this.treeData = this.handleTreeData(data);
  
        
        let data2;
        if (this.template.myTemplate) {
          data2 = _.cloneDeep(this.template.myTemplate);
        } else {
          data2 = _.cloneDeep(this.data);
          this.template.myTemplate = _.cloneDeep(this.data);
        }
        // 生成自定义模板
        this.treeData2 = this.handleTreeData2(data2);
        
  
  
        this.isShowTree = false;
        this.$nextTick(() => {
          this.isShowTree = true;
        });
      },
      async uploadTemplate() {
        const templateString = JSON.stringify(this.template);
        const response = await this.$apollo.mutate({
          mutation: gql`mutation($template: String!){
            doctorSaveTemplate(template:$template)
          }`,
          variables: {
            template: templateString,
          },
        });
        if (response.data.doctorSaveTemplate === null) {
          this.$message({
            message: '成功',
            type: 'success'
          });
        }
        this.$emit('cloneTemplate', this.template);
      },
      // 阻止菜单右键点击冒泡
      menuRightClick(e) {
        e.stopPropagation();
      },
      scrollChange() {
        this.contextmenuNode = false;
        this.contextmenuTpl = false;
        this.contextmenuSecond = false;
        this.contextmenuClass = false;
      },
    },
    watch: {
      // 树结构数据筛选
      filterText(val) {
        this.$refs.tree.filter(val);
      },
      filterText2(val) {
        const arr = [];
        if (val) {
          const f = (data) => {
            for (const item of data) {
              if (item.node) {
                if (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
                  arr.push(item.id);
                  if (item.children && item.children.length) {
                    for (const disItem of item.children) {
                      arr.push(disItem.id);
                    }
                  }
                }
              }
              if (item.children && item.children.length) {
                f(item.children);
              }
            }
          };
          f(this.treeData2);
        }
        this.filterIdArr2 = arr;
        this.$refs.tree2.filter(val);
      },
      diagnoseType: {
        handler(val) {
          if (val !== '') {
            this.addTemplate();
          }
          this.filterText = '';
          this.filterText2 = '';
        },
      },
      treeReload() {
        this.request();
      },
    },
    async mounted() {
      this.request();
      // document点击或右击tree右击菜单消失
      document.onclick = () => {
        this.contextmenuNode = false;
        this.contextmenuTpl = false;
        this.contextmenuSecond = false;
        this.contextmenuClass = false;
      };
      document.onmousedown = (event) => {
        if (event.button === 2) {
          this.contextmenuNode = false;
          this.contextmenuTpl = false;
          this.contextmenuSecond = false;
          this.contextmenuClass = false;
        }
      };
      const res = await axios.request({
        method: 'get',
        url: api.knowledgeDic
      });
      if (res.data) {
        this.knowledgeDic = res.data;
      }
    },
  }
</script>

<style lang="less">
@import "../assets/style/style";
#tree-wrapper{
  position: absolute;
  left: 7%;
  right: 7%;
  top: 0;
  bottom: 0;
  .primeval-template{
    position: absolute;
    left: 0;
    right: 0;
    top: 38px;
    bottom: 0;
  }
  .custom-template{
    position: absolute;
    left: 0;
    right: 0;
    top: 38px;
    bottom: 0;
  }
  .tree-box{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 48px;
    padding-bottom: 100px;
    overflow-y: auto;
  }
  .toggle-wrap{
    position: absolute;
    left: -7%;
    top: 0;
    right: -7%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border-bottom: 2px solid rgb(97,162,191);
    height: 38px;
    .toggle-btn-box{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }
    .toggle-btn{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50%;
      height: 100%;
      box-sizing: border-box;
      color: @sColor;
      text-align: center;
      cursor: pointer;
      user-select: none;
    }
    .toggle-btn + .toggle-btn{
      border-left: 1px solid rgb(159,203,219);
    }
    .toggle-btn.active{
      background-color: rgb(191,219,230);
    }
  }
  .delete-wrap{
    .delete-item{
      display: flex;
      margin-bottom: 10px;
      .value{
        flex: 1;
        color: #888;
        word-break: break-word;
      }
      .delete-btn{
        width: 40px;
        margin-left: 20px;
        color: #3881cc;
        user-select: none;
        cursor: pointer;
      }
    }
  }
  .contextmenu{
    width: 110px;
    position: fixed;
    cursor: default;
    border: 1px solid #888;
    border-radius: 10px;
    overflow: hidden;
    background-color: #eee;
    line-height: 30px;
    font-size: 14px;
    font-weight: bold;
    .item{
      height: 30px;
      padding-left: 15px;
    }
    .item + .item{
      border-top: 1px solid #888;
    }
    .item:hover{
      background-color: #f4f4f4;
    }
  }
  .contextmenu-node{

  }
}
/*修改tree插件样式*/
.my_tree .el-tree-node__content{
  height: auto;
}
.my_tree .el-tree-node{
  white-space: pre-wrap;
  padding: 0;
}
.my_tree .v-modal{
  z-index: 0 !important;
}
.my_tree .el-tree-node__expand-icon{
  margin-left: 6px;
  margin-right: 6px;
  padding: 0;
  font-size: 24px;
  color: #111;
}
.my_tree .is-leaf.el-tree-node__expand-icon{
  color: rgba(255, 255, 255, 0);
  display: none;
}
</style>
